import { FC, Dispatch, SetStateAction, useState } from 'react';
import { AlertsDrawerContent } from './AlertsDrawerContent';
import { ChildCaseDrawerContent } from './ChildCaseDrawerContent';
import { AlertInterface } from '../../../interfaces/AlertInterface';
import { SharedDrawer } from '../SharedDrawer';
import { SharedDrawerCustomHeader } from '../SharedDrawerCustomHeader';

interface Props {
  alertsDrawerOpen: boolean;
  setAlertsDrawerOpen: Dispatch<SetStateAction<boolean>>;
  alertsError: boolean;
  alertsLoading: boolean;
  refetchAlerts: () => void;
  setAlertChildCaseOpen: (val: AlertInterface | undefined) => void;
  alertChildCaseOpen: AlertInterface | undefined;
}

export const AlertsDrawer: FC<Props> = ({
  alertsDrawerOpen,
  setAlertsDrawerOpen,
  alertsError,
  alertsLoading,
  refetchAlerts,
  setAlertChildCaseOpen,
  alertChildCaseOpen,
}) => {
  const [showExpiredAlerts, setShowExpiredAlerts] = useState(false);

  const closeAlertsDrawer = () => {
    setAlertsDrawerOpen(false);
    setShowExpiredAlerts(false);
    setAlertChildCaseOpen(undefined);
  };

  return (
    <SharedDrawer
      open={alertsDrawerOpen}
      onClose={closeAlertsDrawer}
      headerName='Alerts & Outages'
      disableBackdropClick
      dataTestId='alerts-drawer'
      contentStyles={{ overflowY: 'hidden' }}
      showHeader={!alertChildCaseOpen && !showExpiredAlerts}
      customHeader={
        alertChildCaseOpen ? (
          <SharedDrawerCustomHeader
            title='This affects my Restaurant'
            onClose={closeAlertsDrawer}
            onBack={() => setAlertChildCaseOpen(undefined)}
          />
        ) : showExpiredAlerts ? (
          <SharedDrawerCustomHeader
            title='Expired Alerts & Outages'
            onClose={closeAlertsDrawer}
            onBack={() => setShowExpiredAlerts(false)}
          />
        ) : undefined
      }
    >
      {alertChildCaseOpen ? (
        <ChildCaseDrawerContent alertChildCaseOpen={alertChildCaseOpen} />
      ) : (
        <AlertsDrawerContent
          alertsDrawerOpen={alertsDrawerOpen}
          alertsError={alertsError}
          alertsLoading={alertsLoading}
          refetchAlerts={refetchAlerts}
          setAlertChildCaseOpen={setAlertChildCaseOpen}
          showExpiredAlerts={showExpiredAlerts}
          setShowExpiredAlerts={setShowExpiredAlerts}
        />
      )}
    </SharedDrawer>
  );
};
